export default "__VITE_ASSET__BpIRRfpa__"